



























































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';
import StatusBadge from '@/componentsV2/atoms/StatusBadge/StatusBadge.vue';
import HeartSolidIcon from '@/components/icons/HeartSolid.vue';
import HeartOutlineIcon from '@/components/icons/HeartOutline.vue';

import { IMemberRelationship } from '@/models/performance';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    StatusBadge,
    TableCard,
    EmptyStateTable,
    HeartSolidIcon,
    HeartOutlineIcon
  }
})
export default class CustomerList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() customers!: IMemberRelationship[];
  @Prop() showCoinsBalance!: boolean;
  @Prop() showFavorited!: boolean;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  detail(rowData: Record<string, any>) {
    this.$emit('item-click', rowData);
    this.$router.push(`/performance/customer-center/${rowData.id}`);
  }
}
